import { deviceMapping } from '../mapping/overview';
import { SETUP_WIZARD_FORM_DATA_KEYS } from '../interface/project.interface';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';

interface SetupWizardTemplate {
    recommendedScreens: Screen[];
    questions: SetupWizardTemplateQuestion[];
    placeholder: string;
}

interface SetupWizardTemplateQuestion {
    type: string;
    questionWording: string;
    questionSubtext: string[];
    importantWording: string[];
}
interface Screen {
    label: string;
    value: string;
    title: string;
}

export const VIDEO_TEMPLATE: SetupWizardTemplate = {
    placeholder: `${STATIC_STORAGE_URL}/usr/f0519519-d5b6-48ca-a598-eadeaa062df3_balljars_trim.mp4`,
    recommendedScreens: [
        deviceMapping.browser,
        deviceMapping.tablet,
        deviceMapping.mobile
    ],
    questions: [
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.NAME,
            questionWording: 'First, give your project a name.',
            questionSubtext: [],
            importantWording: []
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.COUNTRY,
            questionWording: 'What are the markets for your data collection?',
            questionSubtext: [],
            importantWording: [
                'You may use the tool in almost any market and language. The demo is in English only.'
            ]
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.SAMPLE_SIZE,
            questionWording: 'How many completes would you like?',
            questionSubtext: [],
            importantWording: [
                'This helps determine the sample cost if you were to launch a project.'
            ]
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.VIDEO,
            questionWording: 'Upload your test video',
            questionSubtext: [],
            importantWording: []
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.SUPPORTED_DEVICES,
            questionWording:
                'Finally, confirm the supported devices for participants',
            questionSubtext: [],
            importantWording: [
                'inca is supported on all devices, but you may want to deselect certain screens based on your test materials.'
            ]
        }
        // {
        //     type: SETUP_WIZARD_FORM_DATA_KEYS.CHECKOUT,
        //     questionWording: 'Checkout',
        //     questionSubtext: [
        //         'Prices for demonstration purposes only.',
        //         'You will not be charged to launch a test project.'
        //     ],
        //     importantWording: []
        // }
    ]
};

export const COPY_TEMPLATE: SetupWizardTemplate = {
    placeholder: `Never starve again with Green Bank's blossoming cash back rates. Earn 3% cash back on grocery store purchases, and an extra 1% if you shop at an associated Blue Store. That’s 4% total! Wowza!\n\nPlus, stockpile personalized offers for great local organic food healthy brands to double (x2) your savings! All you have to do is download our app from the App Store and link your card.\n\nHave seconds, on us! From your friends at Green Bank.`,
    recommendedScreens: [
        deviceMapping.browser,
        deviceMapping.tablet,
        deviceMapping.mobile
    ],
    questions: [
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.NAME,
            questionWording: 'First, give your project a name.',
            questionSubtext: [],
            importantWording: []
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.COUNTRY,
            questionWording: 'What are the markets for your data collection?',
            questionSubtext: [],
            importantWording: [
                'You may use the tool in almost any market and language. The demo is in English only.'
            ]
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.SAMPLE_SIZE,
            questionWording: 'How many completes would you like?',
            questionSubtext: [],
            importantWording: [
                'This helps determine the sample cost if you were to launch a project.'
            ]
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.COPY_TEXT,
            questionWording: 'Add your test copy',
            questionSubtext: [],
            importantWording: []
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.SUPPORTED_DEVICES,
            questionWording:
                'Finally, confirm the supported devices for participants',
            questionSubtext: [],
            importantWording: [
                'inca is supported on all devices, but you may want to deselect certain screens based on your test materials.'
            ]
        }
    ]
};

export const IMAGE_TEMPLATE: SetupWizardTemplate = {
    placeholder: `${STATIC_STORAGE_URL}/img/happyeats_ad.png`,
    recommendedScreens: [
        deviceMapping.browser,
        deviceMapping.tablet,
        deviceMapping.mobile
    ],
    questions: [
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.NAME,
            questionWording: 'First, give your project a name.',
            questionSubtext: [],
            importantWording: []
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.COUNTRY,
            questionWording: 'What are the markets for your data collection?',
            questionSubtext: [],
            importantWording: [
                'You may use the tool in almost any market and language. The demo is in English only.'
            ]
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.SAMPLE_SIZE,
            questionWording: 'How many completes would you like?',
            questionSubtext: [],
            importantWording: [
                'This helps determine the sample cost if you were to launch a project.'
            ]
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.HOTSPOT,
            questionWording:
                'Upload your image and add the areas you would like to show',
            questionSubtext: [],
            importantWording: []
        },
        {
            type: SETUP_WIZARD_FORM_DATA_KEYS.SUPPORTED_DEVICES,
            questionWording:
                'Finally, confirm the supported devices for participants',
            questionSubtext: [],
            importantWording: [
                'inca is supported on all devices, but you may want to deselect certain screens based on your test materials.'
            ]
        }
    ]
};
